import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const FadeWrapper = styled.div`
  animation-name: ${fadeIn};
  animation-duration: ${(props) => props.duration};
`;

const Fade = ({ duration, style, children }) => (
  <FadeWrapper duration={duration} style={style}>
    {children}
  </FadeWrapper>
);

Fade.propTypes = {
  children: PropTypes.node.isRequired,
  duration: PropTypes.string,
  style: PropTypes.object, // eslint-disable-line
};

Fade.defaultProps = {
  duration: '0.75s',
  style: {},
};

export default Fade;
